/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useContext,
  useReducer,
  useState,
  useEffect,
  useRef,
} from "react";
import { format } from "date-fns";
import { Store } from "../Store";
import MoreVertSharpIcon from "@mui/icons-material/MoreVertSharp";
import axios from "axios";
import { toast } from "react-toastify";
import { getError } from "../LoadingError/Utils";
import {
  Box,
  Menu,
  MenuItem,
  Modal,
  Tooltip,
  Typography,
  tooltipClasses,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
} from "@mui/material";
import { useNavigate, Link } from "react-router-dom";
import "../index.css";
import PostPopupTooltip from "../Components/PostPopupTooltip";
import { styled } from "@mui/material/styles";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { Pagination, Navigation } from "swiper/modules";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "0.1px solid gainsboro",
  borderRadius: "1rem",
  boxShadow: "1px 2px 1px gainsboro",
  p: 4,
};
const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "white",
    color: "black",
    maxWidth: "500px",
    borderRadius: "1rem",
    boxShadow: "1px 2px 1px gainsboro",
    padding: "1rem",
  },
}));
const reducer = (state, action) => {
  switch (action.type) {
    case "FETCHING":
      return { ...state, loading: true };
    case "FETCHED":
      return { ...state, dataUser: action.payload, loading: false };
    case "FETCH_FAILED":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const reducer3 = (state, action) => {
  switch (action.type) {
    case "FETCHING":
      return { ...state, loadingComments: true };
    case "FETCHED":
      return { ...state, dataComments: action.payload, loadingComments: false };
    case "FETCH_FAILED":
      return {
        ...state,
        loadingComments: false,
        errorComments: action.payload,
      };
    default:
      return state;
  }
};

const reducer4 = (state, action) => {
  switch (action.type) {
    case "DELETE_REQUEST":
      return { ...state, loadingDel: true };
    case "DELETE_SUCCESS":
      return { ...state, loadingDel: false };
    case "DELETE_FAIL":
      return { ...state, loadingDel: false };
    default:
      return state;
  }
};

const reducer5 = (state, action) => {
  switch (action.type) {
    case "ADD_REQUEST":
      return { ...state, loadingAdd1: true };
    case "ADD_SUCCESS":
      return { ...state, loadingAdd1: false };
    case "ADD_FAIL":
      return { ...state, loadingAdd1: false };
    default:
      return state;
  }
};

const edits = ["Update Post", "Delete Post"];
const editsAsAdmin = ["Update Post", "Delete Post"];
const editsAsUser = ["Report Post"];

export default function Post(props) {
  const { post } = props;
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo } = state;
  const [anchorElPost, setAnchorElPost] = useState(null);
  const [showModalUpdate, setShowModalUpdate] = useState(false);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [showModalComment, setShowModalComment] = useState(false);
  const [showModalContact, setShowModalContact] = useState(false);
  const [showSignInModalChat, setShowSignInModalChat] = useState(false);
  const [totalLikes, setTotalLikes] = useState(parseInt(post.total_likes));
  const [animate, setAnimate] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");

  const [showShareLink, setShowShareLink] = useState(false);

  const [likes, setLikes] = useState(false);

  const createdDate = new Date(post.created_at);

  const [comment, setComment] = useState("");
  const textareaRef = useRef(null);

  const navigate = useNavigate();

  const formattedDate = createdDate.toLocaleString("en-US", {
    year: "numeric",
    month: "long",
    day: "2-digit",
  });

  const [{ error, dataUser }, dispatch] = useReducer(reducer, {
    dataUser: [],
    loading: true,
    error: "",
  });

  const [{ loadingAdd1 }, dispatch5] = useReducer(reducer5, {
    loadingAdd1: false,
  });

  const [{ loadingComments, errorComments, dataComments }, dispatch3] =
    useReducer(reducer3, {
      dataComments: [],
      loadingComments: true,
      errorComments: "",
    });

  const [{ loadingDel }, dispatch4] = useReducer(reducer4, {
    loadingDel: false,
  });

  useEffect(() => {
    let isMounted = true; // flag to indicate if the component is mounted

    const fetchData = async () => {
      if (userInfo !== null) {
        dispatch({
          type: "FETCHING",
        });

        try {
          const { data } = await axios.get(
            `${process.env.REACT_APP_BACKEND_DOMAIN}/api/users/me`,
            {
              headers: { Authorization: `Bearer ${userInfo.data.token}` },
            }
          );

          if (isMounted) {
            dispatch({
              type: "FETCHED",
              payload: data.data,
            });
          }
        } catch (error) {
          if (isMounted) {
            dispatch({
              type: "FETCH_FAILED",
              payload: error.message,
            });

            if (error.response && error.response.status === 401) {
              // Assuming you have a signoutHandler function
              signoutHandler();
              navigate("/signin");
            } else {
              toast.error(getError(error));
            }
          }
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false; // cleanup function to update the flag when component unmounts
    };
  }, [userInfo]);

  useEffect(() => {
    const fetchData = async () => {
      dispatch3({
        type: "FETCHING",
      });

      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_DOMAIN}/api/posts/getComment?postId=${post.id}`,
          {
            auth: {
              username: `${process.env.REACT_APP_BASIC_AUTH_USERNAME}`,
              password: `${process.env.REACT_APP_BASIC_AUTH_PASSWORD}`,
            },
          }
        );

        dispatch3({
          type: "FETCHED",
          payload: data.data,
        });
      } catch (error) {
        dispatch3({
          type: "FETCH_FAILED",
          payload: error.message,
        });
        toast.error(getError(error));
      }
    };

    fetchData();
    return () => {};
  }, [loadingAdd1, loadingDel, post.id]); // Include dependencies if needed

  const autoHyperlink = (text) => {
    const urlPattern = /(https?:\/\/[^\s]+)/g;
    return text.split(urlPattern).map((part, index) =>
      urlPattern.test(part) ? (
        <a
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-[#F95C3D]"
        >
          {part}
        </a>
      ) : (
        part
      )
    );
  };

  const ReadMore = ({ children }) => {
    const text = children;

    const [showMore, setShowMore] = useState(true);
    if (!text) {
      return <div></div>;
    }
    const toggleReadMore = () => {
      setShowMore(!showMore);
    };

    if (text && text.length <= 100) {
      return (
        <p className="whitespace-pre-wrap break-words">{autoHyperlink(text)}</p>
      );
    } else {
      const sliceLimit = 100;
      const endOfSentence = text.lastIndexOf(" ", sliceLimit);
      const displayText = showMore
        ? text.slice(0, endOfSentence) + "..."
        : text;

      return (
        <p className="whitespace-pre-wrap break-words">
          {autoHyperlink(displayText)}
          <span
            onClick={toggleReadMore}
            className="whitespace-nowrap text-sm text-[#F95C3D] cursor-pointer"
          >
            {showMore ? " read more" : null}
          </span>
        </p>
      );
    }
  };

  const UploadDate = ({ timestamp }) => {
    let currentDate = new Date();
    let uploadDate = new Date(timestamp);

    let diffDate = date_diff_indays(uploadDate, currentDate);
    let date = "";
    if (diffDate >= 604800) {
      date = Math.floor(diffDate / 604800) + "w";
      return date;
    } else if (diffDate >= 86400) {
      date = Math.floor(diffDate / 86400) + "d";
      return date;
    } else if (diffDate >= 3600) {
      date = Math.floor(diffDate / 3600) + "h";
      return date;
    } else if (diffDate >= 60) {
      date = Math.floor(diffDate / 60) + "m";
      return date;
    } else {
      if (diffDate < 0) {
        diffDate = 0;
      }
      date = diffDate + "s";
      return date;
    }
  };

  const date_diff_indays = function (date1, date2) {
    const dt1 = new Date(date1);
    const dt2 = new Date(date2);
    return Math.floor(
      (Date.UTC(
        dt2.getFullYear(),
        dt2.getMonth(),
        dt2.getDate(),
        dt2.getHours(),
        dt2.getMinutes(),
        dt2.getSeconds()
      ) -
        Date.UTC(
          dt1.getFullYear(),
          dt1.getMonth(),
          dt1.getDate(),
          dt1.getHours(),
          dt1.getMinutes(),
          dt1.getSeconds()
        )) /
        1000
    );
  };

  function handleCloseModalContact() {
    setShowModalContact(false);
  }

  function handleSignInButtonModalContact() {
    navigate("/signin");
  }

  function handleCancelButtonModalContact() {
    setShowModalContact(false);
  }

  function SetProfilePicture() {
    const isNull = post.picture;
    if (isNull === "null" || isNull === null) {
      return <DefaultPP />;
    } else {
      return <ProfilePicture />;
    }
  }

  function DefaultPP() {
    return (
      <img
        className="mb-3 mt-3 rounded-full w-12 h-12"
        src="../images/pp/defaultpp.png"
        alt="defaultprofilepicture"
        referrerPolicy="no-referrer"
      />
    );
  }

  function ProfilePicture() {
    return (
      <img
        className="mb-3 mt-3 rounded-full w-12 h-12"
        src={post.picture}
        alt="profilepicture"
        referrerPolicy="no-referrer"
      />
    );
  }

  function SetUsername() {
    if (userInfo !== null) {
      return (
        <p
          className="leading-tight"
          style={{
            maxWidth: "100%",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
          }}
        >
          <>
            {dataUser.user_id !== post.user_id ? (
              <HtmlTooltip
                title={
                  <>
                    <PostPopupTooltip
                      key={post.slug}
                      dataUser={post}
                      totalLikes={totalLikes}
                    />
                  </>
                }
                placement="top"
                slotProps={{
                  popper: {
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: [0, -10],
                        },
                      },
                    ],
                    sx: { zIndex: (theme) => theme.zIndex.tooltip - 999 },
                  },
                }}
              >
                <div className="flex items-center">
                  <a href={`/${post.username}`}>{post.name}</a>
                  <div className="flex items-center ml-2">
                    {post.verified ? (
                      <img
                        className="w-4 h-4"
                        alt="verified"
                        src="../../images/icon_done.png"
                      ></img>
                    ) : (
                      ""
                    )}
                  </div>
                  {/* <div className="flex text-sm items-center ml-2 text-gray-500">
                    @{post.username}
                  </div> */}
                </div>
              </HtmlTooltip>
            ) : (
              <div className="flex items-center">
                <a href={`/${dataUser.username}`}>{post.name}</a>
                <div className="flex items-center ml-2">
                  {post.verified ? (
                    <img
                      className="w-4 h-4"
                      alt="verified"
                      src="../../images/icon_done.png"
                    ></img>
                  ) : (
                    ""
                  )}
                </div>
                {/* <div className="flex text-sm items-center ml-2 text-gray-500">
                  @{post.username}
                </div> */}
              </div>
            )}
            <div className="text-sm text-gray-500 leading-tight">
              {formattedDate}
            </div>
            <div className="text-sm text-gray-500 leading-tight">
              <UploadDate timestamp={post.created_at} />
              {post.location ? `, located in ${post.location}` : ""}
            </div>
          </>
        </p>
      );
    } else {
      return (
        <p
          className="leading-tight"
          style={{
            maxWidth: "100%",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
          }}
        >
          <>
            <div className="flex items-center">
              <div
                className="cursor-pointer"
                onClick={() => setShowSignInModalChat(true)}
              >
                {post.name}
              </div>
              <div className="flex items-center ml-2">
                {post.verified ? (
                  <img
                    className="w-4 h-4"
                    alt="verified"
                    src="../../images/icon_done.png"
                  ></img>
                ) : (
                  ""
                )}
              </div>
              {/* <div className="flex text-sm items-center ml-2 text-gray-500">
                @{post.username}
              </div> */}
            </div>

            <div className="text-sm text-gray-500 leading-tight">
              {formattedDate}
            </div>
            <div className="text-sm text-gray-500 leading-tight">
              <UploadDate timestamp={post.created_at} />
              {post.location ? `, located in ${post.location}` : ""}
            </div>
          </>
        </p>
      );
    }
  }

  // function SetDefaultImage() {
  //   const postImg = post.images || [];
  //   const [currentSlide, setCurrentSlide] = useState(0);

  //   return (
  //     <>
  //       {postImg.length > 0 ? (
  //         <>
  //           <Swiper
  //             modules={[Pagination, Navigation]}
  //             navigation={{
  //               prevEl: ".custom-prev-button",
  //               nextEl: ".custom-next-button",
  //             }}
  //             pagination={{ clickable: true }}
  //             onSlideChange={(swiper) => setCurrentSlide(swiper.activeIndex)}
  //             className="mySwiper rounded-2xl"
  //           >
  //             {postImg.map((image, index) => (
  //               <SwiperSlide key={index}>
  //                 <div className="flex justify-center">
  //                   <div
  //                     className="w-[26rem] h-[26rem] relative bg-white rounded-2xl"
  //                     onDoubleClick={
  //                       !userInfo ? null : () => handleButtonClick(post.id)
  //                     }
  //                     style={{ border: "0.1px solid gainsboro" }}
  //                   >
  //                     <img
  //                       className="w-full h-full object-contain rounded-2xl shadow-none"
  //                       src={image}
  //                       alt="postImage"
  //                     />
  //                   </div>
  //                 </div>
  //               </SwiperSlide>
  //             ))}

  //             <button
  //               className={`hidden rounded-lg bg-white mr-2 py-1 px-1 shadow-md hover:bg-[#F5F5F5] absolute z-10 custom-prev-button ${
  //                 currentSlide === 0 ? "" : "lg:flex"
  //               }`}
  //               style={{
  //                 top: "50%",
  //                 left: "2%",
  //                 transform: "translate(0%, -50%)",
  //               }}
  //               // onClick={handlePreviousClick}
  //             >
  //               <ArrowBackIosNewIcon style={{ fontSize: "medium" }} />
  //             </button>

  //             <button
  //               className={`hidden rounded-lg bg-white ml-2 py-1 px-1 shadow-md hover:bg-[#F5F5F5] absolute z-10 custom-next-button ${
  //                 currentSlide === postImg.length - 1 ? "" : "lg:flex"
  //               }`}
  //               style={{
  //                 top: "50%",
  //                 right: "2%",
  //                 transform: "translate(0%, -50%)",
  //               }}
  //               // onClick={handleNextClick}
  //             >
  //               <ArrowForwardIosIcon style={{ fontSize: "medium" }} />
  //             </button>
  //           </Swiper>
  //         </>
  //       ) : (
  //         <>
  //           {/* <div className="flex justify-center">
  //             <div
  //               className="w-[26rem] h-[26rem] relative bg-white rounded-2xl"
  //               onDoubleClick={
  //                 !userInfo ? null : () => handleButtonClick(post.id)
  //               }
  //               style={{
  //                 border: "0.1px solid gainsboro",
  //               }}
  //             >
  //               <img
  //                 className="w-full h-full object-contain rounded-2xl shadow-none"
  //                 src="../images/default_post.png"
  //                 alt="postImage"
  //               />
  //             </div>
  //           </div> */}
  //         </>
  //       )}
  //     </>
  //   );
  // }

  function SetDefaultImage() {
    const postImg = post.images || [];
    const [currentSlide, setCurrentSlide] = useState(0);
    const videoRef = useRef([]);
    const observerRef = useRef();
  
    useEffect(() => {
      // Create an IntersectionObserver to watch video visibility
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            // Play video when in view
            if (video && video.paused) {
              video.play().catch((err) => console.error("Error playing video:", err));
            }
          } else {
            // Pause video when out of view
            if (video && !video.paused) {
              video.pause();
            }
          }
        });
      }, { threshold: 0.5 }); // Adjust threshold based on when you want to trigger play/pause (50% visible)
  
      // Observe each video
      postImg.forEach((_, index) => {
        if (videoRef.current[index]) {
          observer.observe(videoRef.current[index]);
        }
      });
  
      // Cleanup observer on component unmount
      return () => {
        postImg.forEach((_, index) => {
          if (videoRef.current[index]) {
            observer.unobserve(videoRef.current[index]);
          }
        });
      };
    }, [postImg]);
  
    return (
      <>
        {postImg.length > 0 ? (
          <>
            <Swiper
              modules={[Pagination, Navigation]}
              navigation={{
                prevEl: ".custom-prev-button",
                nextEl: ".custom-next-button",
              }}
              pagination={{ clickable: true }}
              onSlideChange={(swiper) => setCurrentSlide(swiper.activeIndex)}
              className="mySwiper rounded-2xl"
              style={{ border: "0.1px solid gainsboro" }}
            >
              {postImg.map((media, index) => {
                const isVideo = media.includes("smpost-v-");
  
                return (
                  <SwiperSlide key={index}>
                    <div className="flex justify-center">
                      <div
                        className="w-[26rem] h-[26rem] relative bg-white rounded-2xl"
                        onDoubleClick={!userInfo ? null : () => handleButtonClick(post.id)}
                      >
                        {isVideo ? (
                          // Render Video if it's a video
                          <video
                            ref={(el) => (videoRef.current[index] = el)}
                            muted
                            controls
                            className="w-full h-full object-contain rounded-2xl shadow-none"
                          >
                            <source src={media} type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        ) : (
                          // Render Image if it's an image
                          <img
                            className="w-full h-full object-contain rounded-2xl shadow-none"
                            src={media}
                            alt="post media"
                          />
                        )}
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
  
              <button
                className={`hidden rounded-lg bg-white mr-2 py-1 px-1 shadow-md hover:bg-[#F5F5F5] absolute z-10 custom-prev-button ${
                  currentSlide === 0 ? "" : "lg:flex"
                }`}
                style={{
                  top: "50%",
                  left: "2%",
                  transform: "translate(0%, -50%)",
                }}
              >
                <ArrowBackIosNewIcon style={{ fontSize: "medium" }} />
              </button>
  
              <button
                className={`hidden rounded-lg bg-white ml-2 py-1 px-1 shadow-md hover:bg-[#F5F5F5] absolute z-10 custom-next-button ${
                  currentSlide === postImg.length - 1 ? "" : "lg:flex"
                }`}
                style={{
                  top: "50%",
                  right: "2%",
                  transform: "translate(0%, -50%)",
                }}
              >
                <ArrowForwardIosIcon style={{ fontSize: "medium" }} />
              </button>
            </Swiper>
          </>
        ) : (
          <></> // Fallback for no media
        )}
      </>
    );
  }


  const handleOpenUserMenu = (event) => {
    setAnchorElPost(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElPost(null);
  };

  const handleButtonReport = () => {
    setShowReportModal(true);
  };

  const handleCancelReport = () => {
    setShowReportModal(false);
    setSelectedReason("");
  };

  async function handleReportPost(postId, reasonId) {
    // Add your report post logic here
    console.log("POST ID: (REPORT)", postId);
    console.log("Reason ID: (REPORT)", reasonId);
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/posts/reportPost`,
        {
          postId: postId,
          reasonId: reasonId,
        },
        {
          headers: { Authorization: `Bearer ${userInfo.data.token}` },
        }
      );
      toast.success("Post Reported.");
    } catch (error) {
      toast.error(getError(error));
    }
    console.log(`Report reason: ${selectedReason}`);
    setShowReportModal(false);
  }

  const handleReasonChange = (event) => {
    setSelectedReason(event.target.value);
  };

  const modalReportStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    outline: "none",
    borderRadius: "8px",
  };

  function handleOpenUpdate() {
    setAnchorElPost(null);
    setShowModalUpdate(true);
  }

  function handleCloseModalUpdate() {
    setShowModalUpdate(false);
  }
  function handleOpenDelete() {
    setAnchorElPost(null);
    setShowModalDelete(true);
  }

  function handleCloseModalDelete() {
    setShowModalDelete(false);
  }

  const handleCancelButtonModalUpdate = () => {
    setShowModalUpdate(false);
  };
  const handleCancelButtonModalDelete = () => {
    setShowModalDelete(false);
  };

  function handleButtonModalUpdate() {
    navigate("/update_post", { state: { post } });
  }

  const handleButtonModalDelete = async () => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/posts/deletePost/${post.id}`,
        {
          headers: { Authorization: `Bearer ${userInfo.data.token}` },
        }
      );
      toast.success("Post deleted successfully!");
      navigate("/");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      toast.error(getError(error));
    }
  };

  const handleCommentChange = (e) => {
    setComment(e.target.value);
    const textarea = textareaRef.current;
    textarea.style.height = "auto";
    textarea.style.height = `${textarea.scrollHeight}px`;
  };

  async function unlikePostClick(postId) {
    if (userInfo !== null) {
      try {
        await axios.post(
          `${process.env.REACT_APP_BACKEND_DOMAIN}/api/posts/unlikePost`,
          {
            postId: postId,
          },
          {
            headers: { Authorization: `Bearer ${userInfo.data.token}` },
          }
        );

        // Update the likes state for the specific post
        setLikes(false);

        // Decrease the total likes count
        setTotalLikes((prevTotalLikes) => Math.max(0, prevTotalLikes - 1));

        // toast.success("Unliked successfully!");
      } catch (err) {
        console.log(err);
      }
    }
  }

  async function likePostClick(postId) {
    if (userInfo !== null) {
      let like_id = "";
      try {
        const { data } = await axios.post(
          `${process.env.REACT_APP_BACKEND_DOMAIN}/api/posts/likePost`,
          {
            postId: postId,
          },
          {
            headers: { Authorization: `Bearer ${userInfo.data.token}` },
          }
        );

        // Update the likes state for the specific post
        setLikes(true);

        // Increase the total likes count
        setTotalLikes((prevTotalLikes) => prevTotalLikes + 1);

        // toast.success("Like successfully!");
        // like_id = data.data.likeId;

        sendNotification();
      } catch (err) {}
    }
  }

  const sendNotification = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/users/sendNotif`,
        {
          postId: post.id,
          targetUserId: post.user_id,
          notifNumber: 2,
          // detailId: like_id,
        },
        {
          headers: { Authorization: `Bearer ${userInfo.data.token}` },
        }
      );
    } catch (error) {}
  };

  function handleButtonClick(postId) {
    if (likes) {
      unlikePostClick(postId);
    } else {
      likePostClick(postId);
    }
    setAnimate(true);
    setTimeout(() => setAnimate(false), 200);
  }

  useEffect(() => {
    if (post.user_liked === undefined) {
      return;
    }

    setLikes(post.user_liked);
  }, [post.user_liked]);

  function DefaultPPComment() {
    return (
      <img
        src="../images/pp/defaultpp.png"
        alt="defaultprofilepicture"
        style={{ marginTop: "0.1em", maxWidth: "20px", maxHeight: "20px" }}
      />
    );
  }

  const ProfilePictureComment = ({ data }) => {
    return (
      <img
        src={data.picture}
        alt="profilepicture"
        style={{ marginTop: "0.1em", maxWidth: "20px", maxHeight: "20px" }}
      />
    );
  };

  const handleDeleteComment = async (e) => {
    dispatch4({
      type: "DELETE_REQUEST",
    });
    try {
      await axios.delete(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/posts/deleteComment`,
        {
          headers: { Authorization: `Bearer ${userInfo.data.token}` },
          data: {
            postId: post.id,
            commentId: e,
          },
        }
      );

      dispatch4({
        type: "DELETE_SUCCESS",
      });
      toast.success("Comment deleted successfully!");
    } catch (error) {
      dispatch4({
        type: "DELETE_FAIL",
      });
      toast.error(getError(error));
    }
  };

  const signoutHandler = () => {
    ctxDispatch({ type: "USER_SIGNOUT" });
    localStorage.removeItem("userInfo");
  };

  function handleOpenPersonalChat() {
    navigate("/chat", { state: { post } });
  }

  function handleButtonModalDetail() {
    navigate(`/detail_post`, { state: { post } });
  }

  function handleButtonModalDetailComment() {
    navigate(`/detail_post`, { state: { post, scrollToComments: true } });
  }

  const nominal = post.price;
  const price =
    post &&
    post.price &&
    new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: post.abbreviation || "IDR",
      maximumFractionDigits: 0,
    }).format(nominal);

  function handleCloseSignInModalChat() {
    setShowSignInModalChat(false);
  }

  const handleCancelButtonModalChat = () => {
    setShowSignInModalChat(false);
  };

  function handleSignInButtonModalChat() {
    setShowSignInModalChat(false);
    navigate("/signin");
  }

  const typeNames = {
    1: "Product",
    2: "Service",
    3: "Event",
    4: "Job",
    5: "Insight",
    6: "Education",
  };

  const getTypeName = (postType, sdType) => {
    // if (postType === 5 && sdType.value === 1) {
    //   return "Review"; // Adjust as needed if sdType.value should dynamically change the type
    // } else if (postType === 5 && sdType.value === 2) {
    //   return "Question"; // Adjust as needed for sdType.value === 2
    // } else {
    return typeNames[postType] || "Unknown Type";
    // }
  };

  const typeColors = {
    Product: "bg-green-600",
    Service: "bg-blue-600",
    Event: "bg-orange-600",
    Job: "bg-purple-600",
    Insight: "bg-blue-500",
  };

  const defaultColor = "bg-gray-600"; // Default color for unknown types

  const getTypeColor = (postType, sdType) => {
    // if (postType === 5) {
    //   if (sdType.value === 1) {
    //     return typeColors["Review"] || defaultColor;
    //   } else if (sdType.value === 2) {
    //     return typeColors["Question"] || defaultColor;
    //   }
    // }

    // Default to typeColors based on postType if not Review or Question
    return typeColors[typeNames[postType]] || defaultColor;
  };

  const handleCopyLink = () => {
    const postLink = `https://siaphub.com/detail_post?postId=${post.id}`;

    // Copy the link to the clipboard
    navigator.clipboard
      .writeText(postLink)
      .then(() => {
        toast.success("Link copied to clipboard:", postLink);
        // You can provide feedback to the user that the link has been copied if needed
      })
      .catch((err) => {
        toast.error("Unable to copy link to clipboard", err);
        // Handle the error, e.g., show an error message to the user
      });
  };

  return (
    <>
      <div
        key={post.id}
        className="card-post xs:w-screen-90 relative overflow-hidden"
      >
        <div className="absolute right-0 top-0 h-16 w-16">
          <div
            className={`absolute transform rotate-45 text-center font-semibold right-[-50px] top-[20px] w-[170px] h-6 ${getTypeColor(
              post.post_type,
              post.sd_post_type
            )} text-white`}
          >
            {getTypeName(post.post_type, post.sd_post_type)}
          </div>
        </div>
        <div className="flex" style={{ justifyContent: "space-between" }}>
          <div className="profilePost flex">
            <div className="mr-8" style={{ width: "4.0em", marginRight: "2%" }}>
              <SetProfilePicture />
            </div>
            <div
              className="flex items-center"
              style={{ justifyContent: "center" }}
            >
              <SetUsername />
            </div>
          </div>
        </div>
        <div className="flex-col mt-2">
         
          <SetDefaultImage />

          {post.images && post.images.length > 0 ? (
            // icons
            <div className="flex text-[#C0BFBF] my-4 justify-end items-center">
              <div className="flex">
                
                {!userInfo ? (
                  <Tooltip
                    onClick={() => setShowSignInModalChat(true)}
                    title="Like"
                    className="cursor-pointer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className={`h-6 w-6 transform transition-transform duration-1000 ease-in delay-150 ${
                        animate ? "scale-150" : ""
                      }`}
                      viewBox="0 0 20 20"
                      fill={likes ? "#FFDD43" : "currentColor"}
                    >
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                    </svg>
                  </Tooltip>
                ) : (
                  <Tooltip
                    onClick={() => handleButtonClick(post.id)}
                    title="Like"
                    className="cursor-pointer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className={`h-6 w-6 transform transition-transform duration-1000 ease-in delay-150 ${
                        animate ? "scale-150" : ""
                      }`}
                      viewBox="0 0 20 20"
                      fill={likes ? "#FFDD43" : "currentColor"}
                    >
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                    </svg>
                  </Tooltip>
                )}
                <p className="ml-2">{totalLikes}</p>
              </div>
              <div className="flex ml-4">
                {!userInfo ? (
                  <Tooltip
                    onClick={() => setShowSignInModalChat(true)}
                    title="Comment"
                    className="cursor-pointer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </Tooltip>
                ) : (
                  <Tooltip
                    onClick={handleButtonModalDetailComment}
                    title="Comment"
                    className="cursor-pointer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </Tooltip>
                )}
                <p className="ml-2">{post.total_comments}</p>
              </div>
              <div className="flex ml-4">
                {!userInfo ? (
                  <Tooltip
                    onClick={() => setShowSignInModalChat(true)}
                    title="Share Post"
                    className="cursor-pointer"
                  >
                    <svg
                      width="22"
                      height="20"
                      viewBox="0 0 22 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.1659 0.0814048C13.3083 0.0154397 13.4674 -0.0112655 13.6251 0.00433291C13.7828 0.0199313 13.9327 0.0772059 14.0577 0.169629L21.6729 5.78386C21.7711 5.85614 21.8512 5.94803 21.9077 6.053C21.9642 6.15797 21.9955 6.27345 21.9996 6.39121C22.0036 6.50897 21.9802 6.62614 21.9311 6.73436C21.8819 6.84259 21.8082 6.93922 21.7152 7.01739L14.1 13.4337C13.978 13.5363 13.8274 13.6034 13.6662 13.6268C13.5049 13.6501 13.34 13.6289 13.1912 13.5655C13.0425 13.5021 12.9162 13.3993 12.8276 13.2695C12.7391 13.1397 12.692 12.9883 12.692 12.8337V9.71543C12.2926 9.77959 11.7714 9.89188 11.1622 10.0844C9.68486 10.5528 7.68629 11.4943 5.67587 13.4016C5.55286 13.5186 5.39472 13.5968 5.22307 13.6254C5.05141 13.6541 4.87461 13.6317 4.71684 13.5615C4.55907 13.4913 4.42802 13.3766 4.34161 13.2332C4.25519 13.0897 4.21763 12.9244 4.23406 12.7599C4.47605 10.24 5.25111 8.4017 6.3054 7.07674C7.21029 5.93313 8.44 5.05739 9.8507 4.55194C10.7606 4.22506 11.7199 4.03876 12.692 4.00014V0.803235C12.6917 0.652918 12.736 0.505542 12.8197 0.377914C12.9035 0.250286 13.0235 0.147544 13.1659 0.0814048ZM0 5.61543C0 4.55187 0.445731 3.53187 1.23914 2.77982C2.03254 2.02777 3.10863 1.60527 4.23068 1.60527H7.61522C7.83962 1.60527 8.05484 1.68977 8.21352 1.84018C8.3722 1.99059 8.46135 2.19459 8.46135 2.4073C8.46135 2.62001 8.3722 2.82401 8.21352 2.97442C8.05484 3.12483 7.83962 3.20933 7.61522 3.20933H4.23068C3.55745 3.20933 2.9118 3.46283 2.43575 3.91406C1.95971 4.3653 1.69227 4.9773 1.69227 5.61543V15.2398C1.69227 15.878 1.95971 16.49 2.43575 16.9412C2.9118 17.3924 3.55745 17.6459 4.23068 17.6459H14.3843C15.0575 17.6459 15.7032 17.3924 16.1792 16.9412C16.6553 16.49 16.9227 15.878 16.9227 15.2398V13.6358C16.9227 13.4231 17.0118 13.2191 17.1705 13.0686C17.3292 12.9182 17.5444 12.8337 17.7688 12.8337C17.9932 12.8337 18.2085 12.9182 18.3671 13.0686C18.5258 13.2191 18.615 13.4231 18.615 13.6358V15.2398C18.615 16.3034 18.1692 17.3234 17.3758 18.0754C16.5824 18.8275 15.5063 19.25 14.3843 19.25H4.23068C3.10863 19.25 2.03254 18.8275 1.23914 18.0754C0.445731 17.3234 0 16.3034 0 15.2398V5.61543Z"
                        fill="currentColor"
                      />
                    </svg>
                  </Tooltip>
                ) : (
                  <Tooltip
                    onClick={handleCopyLink}
                    title="Share Post"
                    className="cursor-pointer"
                  >
                    <svg
                      width="22"
                      height="20"
                      viewBox="0 0 22 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.1659 0.0814048C13.3083 0.0154397 13.4674 -0.0112655 13.6251 0.00433291C13.7828 0.0199313 13.9327 0.0772059 14.0577 0.169629L21.6729 5.78386C21.7711 5.85614 21.8512 5.94803 21.9077 6.053C21.9642 6.15797 21.9955 6.27345 21.9996 6.39121C22.0036 6.50897 21.9802 6.62614 21.9311 6.73436C21.8819 6.84259 21.8082 6.93922 21.7152 7.01739L14.1 13.4337C13.978 13.5363 13.8274 13.6034 13.6662 13.6268C13.5049 13.6501 13.34 13.6289 13.1912 13.5655C13.0425 13.5021 12.9162 13.3993 12.8276 13.2695C12.7391 13.1397 12.692 12.9883 12.692 12.8337V9.71543C12.2926 9.77959 11.7714 9.89188 11.1622 10.0844C9.68486 10.5528 7.68629 11.4943 5.67587 13.4016C5.55286 13.5186 5.39472 13.5968 5.22307 13.6254C5.05141 13.6541 4.87461 13.6317 4.71684 13.5615C4.55907 13.4913 4.42802 13.3766 4.34161 13.2332C4.25519 13.0897 4.21763 12.9244 4.23406 12.7599C4.47605 10.24 5.25111 8.4017 6.3054 7.07674C7.21029 5.93313 8.44 5.05739 9.8507 4.55194C10.7606 4.22506 11.7199 4.03876 12.692 4.00014V0.803235C12.6917 0.652918 12.736 0.505542 12.8197 0.377914C12.9035 0.250286 13.0235 0.147544 13.1659 0.0814048ZM0 5.61543C0 4.55187 0.445731 3.53187 1.23914 2.77982C2.03254 2.02777 3.10863 1.60527 4.23068 1.60527H7.61522C7.83962 1.60527 8.05484 1.68977 8.21352 1.84018C8.3722 1.99059 8.46135 2.19459 8.46135 2.4073C8.46135 2.62001 8.3722 2.82401 8.21352 2.97442C8.05484 3.12483 7.83962 3.20933 7.61522 3.20933H4.23068C3.55745 3.20933 2.9118 3.46283 2.43575 3.91406C1.95971 4.3653 1.69227 4.9773 1.69227 5.61543V15.2398C1.69227 15.878 1.95971 16.49 2.43575 16.9412C2.9118 17.3924 3.55745 17.6459 4.23068 17.6459H14.3843C15.0575 17.6459 15.7032 17.3924 16.1792 16.9412C16.6553 16.49 16.9227 15.878 16.9227 15.2398V13.6358C16.9227 13.4231 17.0118 13.2191 17.1705 13.0686C17.3292 12.9182 17.5444 12.8337 17.7688 12.8337C17.9932 12.8337 18.2085 12.9182 18.3671 13.0686C18.5258 13.2191 18.615 13.4231 18.615 13.6358V15.2398C18.615 16.3034 18.1692 17.3234 17.3758 18.0754C16.5824 18.8275 15.5063 19.25 14.3843 19.25H4.23068C3.10863 19.25 2.03254 18.8275 1.23914 18.0754C0.445731 17.3234 0 16.3034 0 15.2398V5.61543Z"
                        fill="currentColor"
                      />
                    </svg>
                  </Tooltip>
                )}
              </div>
              <div className="flex ml-4">
                {dataUser.user_id === post.user_id && userInfo !== null ? (
                  <div className="flex items-center">
                    <Tooltip title="More">
                      <MoreVertSharpIcon
                        onClick={handleOpenUserMenu}
                        style={{ cursor: "pointer" }}
                      />
                    </Tooltip>
                    <Menu
                      sx={{ mt: "0px" }} // Adjust this value if needed
                      id="menu-appbar"
                      anchorEl={anchorElPost}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                      }}
                      open={Boolean(anchorElPost)}
                      onClose={handleCloseUserMenu}
                      PaperProps={{
                        sx: {
                          borderRadius: "0.5rem",
                        },
                      }}
                    >
                      {edits.map((edit) => (
                        <MenuItem key={edit}>
                          {edit === "Report Post" ? (
                            <button onClick={() => handleButtonReport(post.id)}>
                              <Typography
                                textAlign="center"
                                className="no-underline text-black"
                              >
                                {edit}
                              </Typography>
                            </button>
                          ) : edit === "Update Post" ? (
                            <button onClick={handleOpenUpdate}>
                              <Typography
                                textAlign="center"
                                className="no-underline text-black"
                              >
                                {edit}
                              </Typography>{" "}
                            </button>
                          ) : (
                            <button onClick={handleOpenDelete}>
                              <Typography
                                textAlign="center"
                                className="no-underline text-black"
                              >
                                {edit}
                              </Typography>{" "}
                            </button>
                          )}
                        </MenuItem>
                      ))}
                    </Menu>
                  </div>
                ) : (
                  ""
                )}
                {dataUser.is_admin === true &&
                dataUser.user_id !== post.user_id &&
                userInfo !== null ? (
                  <div className="flex items-center">
                    <Tooltip title="Delete Post">
                      <MoreVertSharpIcon
                        onClick={handleOpenUserMenu}
                        style={{ cursor: "pointer" }}
                      />
                    </Tooltip>
                    <Menu
                      sx={{ mt: "0px" }} // Adjust this value if needed
                      id="menu-appbar"
                      anchorEl={anchorElPost}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                      }}
                      open={Boolean(anchorElPost)}
                      onClose={handleCloseUserMenu}
                      PaperProps={{
                        sx: {
                          borderRadius: "0.5rem",
                        },
                      }}
                    >
                      {editsAsAdmin.map((editAsAdmin) => (
                        <MenuItem key={editAsAdmin}>
                          {editAsAdmin === "Update Post" ? (
                            <button onClick={handleOpenUpdate}>
                              <Typography
                                textAlign="center"
                                className="no-underline text-black"
                              >
                                {editAsAdmin}
                              </Typography>{" "}
                            </button>
                          ) : (
                            <button onClick={handleOpenDelete}>
                              <Typography
                                textAlign="center"
                                className="no-underline text-black"
                              >
                                {editAsAdmin}
                              </Typography>{" "}
                            </button>
                          )}
                        </MenuItem>
                      ))}
                    </Menu>
                  </div>
                ) : (
                  ""
                )}
                {dataUser.user_id !== post.user_id &&
                dataUser.is_admin !== true &&
                userInfo !== null ? (
                  <div className="flex items-center">
                    <Tooltip title="More">
                      <MoreVertSharpIcon
                        onClick={handleOpenUserMenu}
                        style={{ cursor: "pointer" }}
                      />
                    </Tooltip>
                    <Menu
                      sx={{ mt: "0px" }} // Adjust this value if needed
                      id="menu-appbar"
                      anchorEl={anchorElPost}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                      }}
                      open={Boolean(anchorElPost)}
                      onClose={handleCloseUserMenu}
                      PaperProps={{
                        sx: {
                          borderRadius: "0.5rem",
                        },
                      }}
                    >
                      {editsAsUser.map((edit) => (
                        <MenuItem key={edit}>
                          <button onClick={() => handleButtonReport(post.id)}>
                            <Typography
                              textAlign="center"
                              className="no-underline text-black"
                            >
                              {edit}
                            </Typography>{" "}
                          </button>
                        </MenuItem>
                      ))}
                    </Menu>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>

        <div className="text-lg font-bold">{post.posttitle}</div>
        {post.images && post.images.length > 0 ? (
          <></>
        ) : (
          <div className="mt-3">
            <ReadMore>{post.description}</ReadMore>
          </div>
        )}

        <div className="flex justify-between items-center flex-row space-x-2">
          <div className="text-xl font-bold order-first">
            {nominal !== undefined && (
              <span>{nominal === 0 ? "Free" : price}</span>
            )}
          </div>

          {post.images && post.images.length > 0 ? (
            <></>
          ) : (
            <div className="flex text-[#C0BFBF] my-4 justify-end items-center">
              <div className="flex">
                {!userInfo ? (
                  <Tooltip
                    onClick={() => setShowSignInModalChat(true)}
                    title="Like"
                    className="cursor-pointer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className={`h-6 w-6 transform transition-transform duration-1000 ease-in delay-150 ${
                        animate ? "scale-150" : ""
                      }`}
                      viewBox="0 0 20 20"
                      fill={likes ? "#FFDD43" : "currentColor"}
                    >
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                    </svg>
                  </Tooltip>
                ) : (
                  <Tooltip
                    onClick={() => handleButtonClick(post.id)}
                    title="Like"
                    className="cursor-pointer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className={`h-6 w-6 transform transition-transform duration-1000 ease-in delay-150 ${
                        animate ? "scale-150" : ""
                      }`}
                      viewBox="0 0 20 20"
                      fill={likes ? "#FFDD43" : "currentColor"}
                    >
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                    </svg>
                  </Tooltip>
                )}
                <p className="ml-2">{totalLikes}</p>
              </div>
              <div className="flex ml-4">
                {!userInfo ? (
                  <Tooltip
                    onClick={() => setShowSignInModalChat(true)}
                    title="Comment"
                    className="cursor-pointer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </Tooltip>
                ) : (
                  <Tooltip
                    onClick={handleButtonModalDetailComment}
                    title="Comment"
                    className="cursor-pointer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </Tooltip>
                )}
                <p className="ml-2">{post.total_comments}</p>
              </div>
              <div className="flex ml-4">
                {!userInfo ? (
                  <Tooltip
                    onClick={() => setShowSignInModalChat(true)}
                    title="Share Post"
                    className="cursor-pointer"
                  >
                    <svg
                      width="22"
                      height="20"
                      viewBox="0 0 22 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.1659 0.0814048C13.3083 0.0154397 13.4674 -0.0112655 13.6251 0.00433291C13.7828 0.0199313 13.9327 0.0772059 14.0577 0.169629L21.6729 5.78386C21.7711 5.85614 21.8512 5.94803 21.9077 6.053C21.9642 6.15797 21.9955 6.27345 21.9996 6.39121C22.0036 6.50897 21.9802 6.62614 21.9311 6.73436C21.8819 6.84259 21.8082 6.93922 21.7152 7.01739L14.1 13.4337C13.978 13.5363 13.8274 13.6034 13.6662 13.6268C13.5049 13.6501 13.34 13.6289 13.1912 13.5655C13.0425 13.5021 12.9162 13.3993 12.8276 13.2695C12.7391 13.1397 12.692 12.9883 12.692 12.8337V9.71543C12.2926 9.77959 11.7714 9.89188 11.1622 10.0844C9.68486 10.5528 7.68629 11.4943 5.67587 13.4016C5.55286 13.5186 5.39472 13.5968 5.22307 13.6254C5.05141 13.6541 4.87461 13.6317 4.71684 13.5615C4.55907 13.4913 4.42802 13.3766 4.34161 13.2332C4.25519 13.0897 4.21763 12.9244 4.23406 12.7599C4.47605 10.24 5.25111 8.4017 6.3054 7.07674C7.21029 5.93313 8.44 5.05739 9.8507 4.55194C10.7606 4.22506 11.7199 4.03876 12.692 4.00014V0.803235C12.6917 0.652918 12.736 0.505542 12.8197 0.377914C12.9035 0.250286 13.0235 0.147544 13.1659 0.0814048ZM0 5.61543C0 4.55187 0.445731 3.53187 1.23914 2.77982C2.03254 2.02777 3.10863 1.60527 4.23068 1.60527H7.61522C7.83962 1.60527 8.05484 1.68977 8.21352 1.84018C8.3722 1.99059 8.46135 2.19459 8.46135 2.4073C8.46135 2.62001 8.3722 2.82401 8.21352 2.97442C8.05484 3.12483 7.83962 3.20933 7.61522 3.20933H4.23068C3.55745 3.20933 2.9118 3.46283 2.43575 3.91406C1.95971 4.3653 1.69227 4.9773 1.69227 5.61543V15.2398C1.69227 15.878 1.95971 16.49 2.43575 16.9412C2.9118 17.3924 3.55745 17.6459 4.23068 17.6459H14.3843C15.0575 17.6459 15.7032 17.3924 16.1792 16.9412C16.6553 16.49 16.9227 15.878 16.9227 15.2398V13.6358C16.9227 13.4231 17.0118 13.2191 17.1705 13.0686C17.3292 12.9182 17.5444 12.8337 17.7688 12.8337C17.9932 12.8337 18.2085 12.9182 18.3671 13.0686C18.5258 13.2191 18.615 13.4231 18.615 13.6358V15.2398C18.615 16.3034 18.1692 17.3234 17.3758 18.0754C16.5824 18.8275 15.5063 19.25 14.3843 19.25H4.23068C3.10863 19.25 2.03254 18.8275 1.23914 18.0754C0.445731 17.3234 0 16.3034 0 15.2398V5.61543Z"
                        fill="currentColor"
                      />
                    </svg>
                  </Tooltip>
                ) : (
                  <Tooltip
                    onClick={handleCopyLink}
                    title="Share Post"
                    className="cursor-pointer"
                  >
                    <svg
                      width="22"
                      height="20"
                      viewBox="0 0 22 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.1659 0.0814048C13.3083 0.0154397 13.4674 -0.0112655 13.6251 0.00433291C13.7828 0.0199313 13.9327 0.0772059 14.0577 0.169629L21.6729 5.78386C21.7711 5.85614 21.8512 5.94803 21.9077 6.053C21.9642 6.15797 21.9955 6.27345 21.9996 6.39121C22.0036 6.50897 21.9802 6.62614 21.9311 6.73436C21.8819 6.84259 21.8082 6.93922 21.7152 7.01739L14.1 13.4337C13.978 13.5363 13.8274 13.6034 13.6662 13.6268C13.5049 13.6501 13.34 13.6289 13.1912 13.5655C13.0425 13.5021 12.9162 13.3993 12.8276 13.2695C12.7391 13.1397 12.692 12.9883 12.692 12.8337V9.71543C12.2926 9.77959 11.7714 9.89188 11.1622 10.0844C9.68486 10.5528 7.68629 11.4943 5.67587 13.4016C5.55286 13.5186 5.39472 13.5968 5.22307 13.6254C5.05141 13.6541 4.87461 13.6317 4.71684 13.5615C4.55907 13.4913 4.42802 13.3766 4.34161 13.2332C4.25519 13.0897 4.21763 12.9244 4.23406 12.7599C4.47605 10.24 5.25111 8.4017 6.3054 7.07674C7.21029 5.93313 8.44 5.05739 9.8507 4.55194C10.7606 4.22506 11.7199 4.03876 12.692 4.00014V0.803235C12.6917 0.652918 12.736 0.505542 12.8197 0.377914C12.9035 0.250286 13.0235 0.147544 13.1659 0.0814048ZM0 5.61543C0 4.55187 0.445731 3.53187 1.23914 2.77982C2.03254 2.02777 3.10863 1.60527 4.23068 1.60527H7.61522C7.83962 1.60527 8.05484 1.68977 8.21352 1.84018C8.3722 1.99059 8.46135 2.19459 8.46135 2.4073C8.46135 2.62001 8.3722 2.82401 8.21352 2.97442C8.05484 3.12483 7.83962 3.20933 7.61522 3.20933H4.23068C3.55745 3.20933 2.9118 3.46283 2.43575 3.91406C1.95971 4.3653 1.69227 4.9773 1.69227 5.61543V15.2398C1.69227 15.878 1.95971 16.49 2.43575 16.9412C2.9118 17.3924 3.55745 17.6459 4.23068 17.6459H14.3843C15.0575 17.6459 15.7032 17.3924 16.1792 16.9412C16.6553 16.49 16.9227 15.878 16.9227 15.2398V13.6358C16.9227 13.4231 17.0118 13.2191 17.1705 13.0686C17.3292 12.9182 17.5444 12.8337 17.7688 12.8337C17.9932 12.8337 18.2085 12.9182 18.3671 13.0686C18.5258 13.2191 18.615 13.4231 18.615 13.6358V15.2398C18.615 16.3034 18.1692 17.3234 17.3758 18.0754C16.5824 18.8275 15.5063 19.25 14.3843 19.25H4.23068C3.10863 19.25 2.03254 18.8275 1.23914 18.0754C0.445731 17.3234 0 16.3034 0 15.2398V5.61543Z"
                        fill="currentColor"
                      />
                    </svg>
                  </Tooltip>
                )}
              </div>
              <div className="flex ml-4">
                {dataUser.user_id === post.user_id && userInfo !== null ? (
                  <div className="flex items-center">
                    <Tooltip title="More">
                      <MoreVertSharpIcon
                        onClick={handleOpenUserMenu}
                        style={{ cursor: "pointer" }}
                      />
                    </Tooltip>
                    <Menu
                      sx={{ mt: "0px" }} // Adjust this value if needed
                      id="menu-appbar"
                      anchorEl={anchorElPost}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                      }}
                      open={Boolean(anchorElPost)}
                      onClose={handleCloseUserMenu}
                      PaperProps={{
                        sx: {
                          borderRadius: "0.5rem",
                        },
                      }}
                    >
                      {edits.map((edit) => (
                        <MenuItem key={edit}>
                          {edit === "Report Post" ? (
                            <button onClick={() => handleButtonReport(post.id)}>
                              <Typography
                                textAlign="center"
                                className="no-underline text-black"
                              >
                                {edit}
                              </Typography>
                            </button>
                          ) : edit === "Update Post" ? (
                            <button onClick={handleOpenUpdate}>
                              <Typography
                                textAlign="center"
                                className="no-underline text-black"
                              >
                                {edit}
                              </Typography>{" "}
                            </button>
                          ) : (
                            <button onClick={handleOpenDelete}>
                              <Typography
                                textAlign="center"
                                className="no-underline text-black"
                              >
                                {edit}
                              </Typography>{" "}
                            </button>
                          )}
                        </MenuItem>
                      ))}
                    </Menu>
                  </div>
                ) : (
                  ""
                )}
                {dataUser.is_admin === true &&
                dataUser.user_id !== post.user_id &&
                userInfo !== null ? (
                  <div className="flex items-center">
                    <Tooltip title="Delete Post">
                      <MoreVertSharpIcon
                        onClick={handleOpenUserMenu}
                        style={{ cursor: "pointer" }}
                      />
                    </Tooltip>
                    <Menu
                      sx={{ mt: "0px" }} // Adjust this value if needed
                      id="menu-appbar"
                      anchorEl={anchorElPost}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                      }}
                      open={Boolean(anchorElPost)}
                      onClose={handleCloseUserMenu}
                      PaperProps={{
                        sx: {
                          borderRadius: "0.5rem",
                        },
                      }}
                    >
                      {editsAsAdmin.map((editAsAdmin) => (
                        <MenuItem key={editAsAdmin}>
                          {editAsAdmin === "Update Post" ? (
                            <button onClick={handleOpenUpdate}>
                              <Typography
                                textAlign="center"
                                className="no-underline text-black"
                              >
                                {editAsAdmin}
                              </Typography>{" "}
                            </button>
                          ) : (
                            <button onClick={handleOpenDelete}>
                              <Typography
                                textAlign="center"
                                className="no-underline text-black"
                              >
                                {editAsAdmin}
                              </Typography>{" "}
                            </button>
                          )}
                        </MenuItem>
                      ))}
                    </Menu>
                  </div>
                ) : (
                  ""
                )}
                {dataUser.user_id !== post.user_id &&
                dataUser.is_admin !== true &&
                userInfo !== null ? (
                  <div className="flex items-center">
                    <Tooltip title="More">
                      <MoreVertSharpIcon
                        onClick={handleOpenUserMenu}
                        style={{ cursor: "pointer" }}
                      />
                    </Tooltip>
                    <Menu
                      sx={{ mt: "0px" }} // Adjust this value if needed
                      id="menu-appbar"
                      anchorEl={anchorElPost}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                      }}
                      open={Boolean(anchorElPost)}
                      onClose={handleCloseUserMenu}
                      PaperProps={{
                        sx: {
                          borderRadius: "0.5rem",
                        },
                      }}
                    >
                      {editsAsUser.map((edit) => (
                        <MenuItem key={edit}>
                          <button onClick={() => handleButtonReport(post.id)}>
                            <Typography
                              textAlign="center"
                              className="no-underline text-black"
                            >
                              {edit}
                            </Typography>{" "}
                          </button>
                        </MenuItem>
                      ))}
                    </Menu>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          )}
        </div>
        {post.images && post.images.length > 0 ? (
          <div className="mt-3">
            <ReadMore>{post.description}</ReadMore>
          </div>
        ) : (
          <></>
        )}

        <Modal
          open={showModalContact}
          onClose={handleCloseModalContact}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="modal-notification-style">
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              style={{
                marginBottom: "10%",
                marginTop: "5%",
                textAlign: "center",
              }}
            >
              Sign in to open the contact
            </Typography>
            <div className="flex justify-center">
              <button
                type="button"
                className="py-2 px-4 rounded-lg text-sm bg-[#F95C3D] text-white shadow hover:bg-orange-600 outline-none focus:outline-none mr-2 mb-1 ease-linear transition-all duration-150"
                onClick={handleSignInButtonModalContact}
              >
                Sign in
              </button>
              <button
                type="button"
                className="py-2 px-4 rounded-lg text-sm bg-white text-[#F95C3D] shadow hover:bg-[#F5F5F5] outline-none focus:outline-none ml-2 mb-1 ease-linear transition-all duration-150"
                onClick={handleCancelButtonModalContact}
              >
                Cancel
              </button>
            </div>
          </Box>
        </Modal>

        {post.tag && Object.keys(post.tag).length > 0 ? (
          <div className="flex rounded-lg mt-3 py-2 overflow-x-auto">
            {Object.keys(post.tag).map((key) => (
              <div
                className="rounded-lg text-[#F95C3D] font-bold mr-2 p-1"
                key={key}
              >
                {post.tag[key]}
              </div>
            ))}
          </div>
        ) : null}

        <div className="flex text-[#C0BFBF] mt-4 justify-end">
          {!userInfo ? (
            <div
              onClick={() => setShowSignInModalChat(true)}
              className="text-[#F95C3D] cursor-pointer flex"
            >
              See details
              <div className="flex items-center ml-2">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 5L5.32288 0L4.2574 1.13904L7.86904 5L4.2574 8.86096L5.32288 10L10 5ZM5.7426 5L1.06548 0L0 1.13904L3.61163 5L0 8.86096L1.06548 10L5.7426 5Z"
                    fill="#F95C3D"
                  />
                </svg>
              </div>
            </div>
          ) : (
            <div
              onClick={handleButtonModalDetail}
              className="text-[#F95C3D] cursor-pointer flex"
            >
              See details
              <div className="flex items-center ml-2">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 5L5.32288 0L4.2574 1.13904L7.86904 5L4.2574 8.86096L5.32288 10L10 5ZM5.7426 5L1.06548 0L0 1.13904L3.61163 5L0 8.86096L1.06548 10L5.7426 5Z"
                    fill="#F95C3D"
                  />
                </svg>
              </div>
            </div>
          )}
        </div>
      </div>

      <Modal
        open={showSignInModalChat}
        onClose={handleCloseSignInModalChat}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal-notification-style">
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            style={{
              marginBottom: "10%",
              marginTop: "5%",
              textAlign: "center",
            }}
          >
            Sign in to use this feature
          </Typography>
          <div className="flex justify-center">
            <button
              type="button"
              className="py-2 px-4 rounded-lg text-sm bg-[#F95C3D] text-white shadow hover:bg-orange-600 outline-none focus:outline-none mr-2 mb-1 ease-linear transition-all duration-150"
              onClick={handleSignInButtonModalChat}
            >
              Sign in
            </button>
            <button
              type="button"
              className="py-2 px-4 rounded-lg text-sm bg-white text-[#F95C3D] shadow hover:bg-[#F5F5F5] outline-none focus:outline-none ml-2 mb-1 ease-linear transition-all duration-150"
              onClick={handleCancelButtonModalChat}
            >
              Cancel
            </button>
          </div>
        </Box>
      </Modal>

      {/* Modal Confirmation Report */}
      <Modal
        open={showReportModal}
        onClose={handleCancelReport}
        aria-labelledby="report-post-title"
        aria-describedby="report-post-description"
      >
        <Box sx={modalReportStyle}>
          <Typography id="report-post-title" variant="h6" component="h2">
            Reason to report post
          </Typography>
          <RadioGroup
            aria-labelledby="report-post-reasons"
            name="report-reasons"
            value={selectedReason}
            onChange={handleReasonChange}
            sx={{ mt: 2 }}
          >
            <FormControlLabel
              value="1"
              control={<Radio />}
              label="Inappropriate"
            />
            <FormControlLabel
              value="2"
              control={<Radio />}
              label="Scam Posts"
            />
            <FormControlLabel value="3" control={<Radio />} label="Spam" />
            <FormControlLabel
              value="4"
              control={<Radio />}
              label="Hate Speech"
            />
            <FormControlLabel value="5" control={<Radio />} label="Violence" />
            <FormControlLabel value="6" control={<Radio />} label="Other" />
          </RadioGroup>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
            <Button onClick={handleCancelReport} sx={{ mr: 2 }}>
              Cancel Report
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleReportPost(post.id, selectedReason)}
              disabled={!selectedReason}
            >
              Report Post
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Modal Confirmation Update */}
      <Modal
        open={showModalUpdate}
        onClose={handleCloseModalUpdate}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal-notification-style">
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            style={{
              marginBottom: "10%",
              marginTop: "5%",
              textAlign: "center",
            }}
          >
            Are you sure want to update this post?
          </Typography>
          <div className="flex justify-center">
            <button
              type="button"
              className="py-2 px-4 rounded-lg text-sm bg-[#F95C3D] text-white shadow hover:bg-orange-600 outline-none focus:outline-none mr-2 mb-1 ease-linear transition-all duration-150"
              onClick={handleButtonModalUpdate}
            >
              Update
            </button>
            <button
              type="button"
              className="py-2 px-4 rounded-lg text-sm bg-white text-[#F95C3D] shadow hover:bg-[#F5F5F5] outline-none focus:outline-none ml-2 mb-1 ease-linear transition-all duration-150"
              onClick={handleCancelButtonModalUpdate}
            >
              Cancel
            </button>
          </div>
        </Box>
      </Modal>

      {/* Modal Confirmation Delete */}
      <Modal
        open={showModalDelete}
        onClose={handleCloseModalDelete}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal-notification-style">
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            style={{
              marginBottom: "10%",
              marginTop: "5%",
              textAlign: "center",
            }}
          >
            Are you sure want to delete this post?
          </Typography>
          <div className="flex justify-center">
            <button
              type="button"
              className="py-2 px-4 rounded-lg text-sm bg-[#F95C3D] text-white shadow hover:bg-orange-600 outline-none focus:outline-none mr-2 mb-1 ease-linear transition-all duration-150"
              onClick={handleButtonModalDelete}
            >
              Delete
            </button>
            <button
              type="button"
              className="py-2 px-4 rounded-lg text-sm bg-white text-[#F95C3D] shadow hover:bg-[#F5F5F5] outline-none focus:outline-none ml-2 mb-1 ease-linear transition-all duration-150"
              onClick={handleCancelButtonModalDelete}
            >
              Cancel
            </button>
          </div>
        </Box>
      </Modal>
    </>
  );
}
